import React from "react";
import { SVG } from "shared";
import { SVG_ENUM, HOME_SCROLL_ENUM } from "enums";
import "./YourInvestitions.scss";
import { fixSierotki } from "utils";

const listItems = [
  {
    header: "Dostęp do danych 24/7 -",
    text: "Wszystkie informacje o posiadanych spółkach i udziale w jednym miejscu, zawsze aktualne",
  },
  {
    header: "Transparentność i kontrola -",
    text: "Pełna historia transakcji, dane o wycenie spółek oraz bieżący status posiadanych udziałów.",
  },
  {
    header: "Wsparcie w podejmowaniu decyzji -",
    text: "Możliwość zlecania analiz rynkowych ułatwia ocenę potencjału inwestycyjnego wybranych spółek.",
  },
  {
    header: "Bezpieczeństwo i dyskrecja -",
    text: "Dostęp do danych zabezpieczony nowoczesnymi rozwiązaniami technologicznymi.",
  },
];

const YourInvestitions: React.FC = () => {
  return (
    <section className="your-investitions">
      <SVG
        className="your-investitions__bg"
        type={SVG_ENUM.YOUR_INVESTITIONS_BACKGROUND}
      />
      <div className="layout" id={HOME_SCROLL_ENUM.WHY_WORTH}>
        <div className="what-investor-needs__top">
          <h2 className="what-investor-needs__header your-investitions__header">
            Państwa inwestycje, <i>Nasze wsparcie</i>
          </h2>
          <p className="what-investor-needs__text your-investitions__text">
            Korzystanie z aplikacji Reliance to większy komfort inwestowania —
            bez konieczności samodzielnego śledzenia rynku. Powiadomienia,
            dostęp do danych i analizy pomagają podejmować decyzje z pewnością i
            spokojem.
          </p>
        </div>
        <div className="your-investitions__content">
          <div className="your-investitions__left">
            <img src={require("assets/images/Laptop.webp")} alt="" />
          </div>
          <div className="your-investitions__right">
            <ul>
              {listItems.map((item, idx) => {
                return (
                  <li className="your-investitions__item" key={idx}>
                    <h3 className="your-investitions__item-header">
                      {item.header}
                    </h3>
                    {fixSierotki(item.text)}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YourInvestitions;
